import React from "react";
import { Button, Typography } from "@material-tailwind/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
 
export function PaginationComponent({nextPage, prevPage, active, totalPages, pageName}) {

  return (
    <div className="flex items-center gap-8 justify-between w-1/4 md:w-100">
      <Button
        size="sm"
        variant="outlined"
        onClick={prevPage}
        disabled={active === 1}
        className={`${active === 1 ? 'text-blueGray-700 bg-blueGray-200' : 'text-white bg-blueGray-700'} font-semibold`}
      >
        <FontAwesomeIcon icon={faArrowLeft}  />
      </Button>
      <Typography color="gray" className="font-normal text-blueGray-700">
        {pageName} <strong className="blueGray-700">{active}</strong> / {" "}
        <strong className="blueGray-700">{totalPages}</strong>
      </Typography>
      <Button
        size="sm"
        variant="outlined"
        onClick={nextPage}
        className={`${active === totalPages ? 'text-blueGray-700 bg-blueGray-200' : 'text-white bg-blueGray-700'} font-semibold`}
        disabled={active === totalPages}
      >
        <FontAwesomeIcon icon={faArrowRight} />
      </Button>
    </div>
  );
}